import React from 'react';
import { blogPosts } from '../data/mock';

const Blog = () => {
  return (
    <section id="blog" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-6 mb-12">
          <div>
            <h2 className="text-[#0a2342] text-3xl md:text-4xl font-bold">
              Insights & Resources
            </h2>
            <p className="text-gray-600 mt-2">Industry perspectives and technical guidance from our experts</p>
          </div>
          <a
            href="#"
            className="px-8 py-3.5 bg-[#0077B6] text-white font-semibold rounded-full hover:bg-[#005f8f] transition-colors uppercase tracking-wide text-sm"
          >
            View All Articles
          </a>
        </div>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <p className="text-[#0077B6] text-sm font-medium mb-2">{post.date}</p>
                <h3 className="text-[#0a2342] font-bold text-lg mb-4 line-clamp-2 group-hover:text-[#0077B6] transition-colors">
                  {post.title}
                </h3>
                <a
                  href="#"
                  className="text-[#0077B6] font-semibold text-sm hover:underline"
                >
                  Read More →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
